// Cliente HTTP da API própria. Sessão por cookie HttpOnly; o front nunca envia tenantId.
export class ApiError extends Error {
  constructor(public status: number, public code: string, message: string, public correlationId?: string, public details?: unknown) {
    super(message);
  }
  get forbidden() { return this.status === 403; }
  get unauthenticated() { return this.status === 401; }
}

let onUnauthenticated: (() => void) | null = null;
export const setUnauthenticatedHandler = (fn: () => void) => { onUnauthenticated = fn; };
// IM-SAAS-003: o servidor relê o vínculo a cada requisição. Um 403 de acesso (perfil alterado, vínculo
// desativado/encerrado, organização suspensa) faz a interface reler a sessão — o papel exibido nunca é a autoridade.
let onAccessChanged: (() => void) | null = null;
export const setAccessChangedHandler = (fn: () => void) => { onAccessChanged = fn; };
const ACCESS_CODES = new Set(['tenant_unresolved', 'forbidden', 'organization_suspended']);

export async function api<T>(path: string, init: { method?: string; body?: unknown; headers?: Record<string, string>; signal?: AbortSignal } = {}): Promise<T> {
  const res = await fetch(path, {
    method: init.method ?? 'GET',
    credentials: 'same-origin',
    signal: init.signal,
    headers: { accept: 'application/json', ...(init.body !== undefined ? { 'content-type': 'application/json' } : {}), ...init.headers },
    body: init.body !== undefined ? JSON.stringify(init.body) : undefined,
  });
  if (res.status === 204) return undefined as T;
  const data = await res.json().catch(() => null);
  if (!res.ok) {
    const err = data?.error ?? {};
    if (res.status === 401 && !path.endsWith('/auth/login')) onUnauthenticated?.();
    if (res.status === 403 && ACCESS_CODES.has(err.code) && path !== '/api/v1/me') onAccessChanged?.();
    throw new ApiError(res.status, err.code ?? 'http_error', err.message ?? `Erro ${res.status}`, err.correlationId, err.details);
  }
  return data as T;
}
